import { render, staticRenderFns } from "./table-data-5.vue?vue&type=template&id=21ca36f3&scoped=true"
import script from "./table-data-5.vue?vue&type=script&lang=js"
export * from "./table-data-5.vue?vue&type=script&lang=js"
import style0 from "./table-data-5.vue?vue&type=style&index=0&id=21ca36f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca36f3",
  null
  
)

export default component.exports